import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Globals} from '../../../../../core/_base/crud/utils/globals.service';

@Injectable()
export class SaveAssIdResolver implements Resolve<any> {
    constructor(private global: Globals) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        const assignmentId = Number(route.paramMap.get('ass_id'));
        this.global.activeAssignmentId = assignmentId;

        return true;
    }
}
